import Vue from 'vue';

export class BaseApi {
  static apiUri = null;

  /** @return {Promise<PagedHttpResponse>} */
  static getAll (params = null) {
    return Vue.http.get(this.apiUri, params);
  }

  /** @return {Promise<EntityHttpResponse>} */
  static getById (id) {
    return Vue.http.get(this.apiUri + '/' + id);
  }

  /** @return {Promise<HttpResponse>} */
  static delete (id) {
    return Vue.http.delete(this.apiUri + '/' + id);
  }
}
